import axios from 'axios';
import { API_BASE_URL, ROUTES } from '@/config/constants';
import router from '@/router';

/**
 * 创建 axios 实例
 */
const request = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
});

// 请求拦截器 - 添加 token
request.interceptors.request.use(
  (config: any) => {
    const token = localStorage.getItem('token');
    if (token) {
      // 将token添加到请求头中
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

// 响应拦截器 - 处理错误
request.interceptors.response.use(
  (response: any) => {
    return response;
  },
  (error: any) => {
    const status = error.response?.status;
    // 处理401错误（token过期或无效）
    if (status === 401) {
      // 清除token
      localStorage.removeItem('token');
      // 跳转到登录页面
      router.push(`/${ROUTES.LOGIN}`);
    }
    return Promise.reject(error);
  }
);

export default request;

